export function toPixelString(value) {
    const intVal = parseInt(value);
    if (isNaN(intVal)) {
        return "1px";
    }

    return intVal + "px";
}

export function toPointNum(pointString) {
    if (!pointString) {
        return 1;
    }
    const numString = pointString.replace("pt", "");
    return parseInt(numString);
}

export function toPointString(value) {
    const intVal = parseInt(value);
    if (isNaN(intVal)) {
        return "1pt";
    }

    return intVal + "pt";
}

export function toPixelNum(pixelString) {
    if (!pixelString) {
        return 1;
    }
    const numString = pixelString.replace("px", "");
    return parseInt(numString);
}